"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Box_1 = __importDefault(require("@mui/material/Box"));
var LinearProgress_1 = __importDefault(require("@mui/material/LinearProgress"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var react_1 = require("@emotion/react");
var ProgressBarHelpers_1 = require("./ProgressBarHelpers");
var makeProgressBarStyling_1 = __importDefault(require("./makeProgressBarStyling"));
var ProgressBar = function (_a) {
    var id = _a.id, progress = _a.progress, text = _a.text, testId = _a.testId;
    var theme = (0, react_1.useTheme)();
    var useLightText = (0, ProgressBarHelpers_1.shouldUseLightText)({
        progressBarFilledColor: theme.mvf.palette.component.progressBarFilledColor,
        progressBarUnfilledColor: theme.mvf.palette.component.progressBarUnfilledColor,
        progress: progress,
    });
    var styles = (0, makeProgressBarStyling_1.default)(theme, useLightText);
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, { css: styles.container, "data-testid": testId, children: [(0, jsx_runtime_1.jsxs)(Typography_1.default, { css: styles.text, children: [text, " ", progress, "%"] }), (0, jsx_runtime_1.jsx)(LinearProgress_1.default, { variant: "determinate", css: styles.progressBar, id: id, value: progress })] }));
};
ProgressBar.defaultProps = defaultProps_1.default;
exports.default = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map